import React, { useState } from 'react';
import {
  FaRegHospital,
  FaShieldAlt,
  FaCertificate,
  FaUserNurse,
  FaLaptopMedical,
  FaBalanceScale,
  FaPaperPlane,
} from 'react-icons/fa';

const services = [
  { title: 'Healthcare Quality Improvement', icon: <FaRegHospital className="text-blue-600 text-9xl" /> },
  { title: 'Patient Safety Audits', icon: <FaShieldAlt className="text-red-500 text-9xl" /> },
  { title: 'Hospital Accreditation Support', icon: <FaCertificate className="text-green-600 text-9xl" /> },
  { title: 'Medical Staff Training & Development', icon: <FaUserNurse className="text-purple-600 text-9xl" /> },
  { title: 'Digital Health Strategy & Implementation', icon: <FaLaptopMedical className="text-teal-600 text-9xl" /> },
  { title: 'Policy & Regulatory Compliance', icon: <FaBalanceScale className="text-yellow-600 text-9xl" /> },
];

const ConsultancyServicesComponent = () => {
  const [selectedService, setSelectedService] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const handleRequestClick = (serviceTitle) => {
    setSelectedService(serviceTitle);
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
    setSelectedService(null);
  };

  return (
    <div className="p-6">
      <h2 className="text-4xl font-bold text-center text-blue-900 mb-10">
        Consultancy Services
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {services.map((service, index) => (
          <div
            key={index}
            style={{ borderRadius: "32px" }}
            className="bg-blue-100 shadow-lg aspect-square p-6 flex flex-col justify-center items-center space-y-4 hover:shadow-lg transition"
          >
            {service.icon}
            <h3 className="text-lg font-semibold text-gray-800 text-center">
              {service.title}
            </h3>
            <button
              className="mt-4 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition flex items-center space-x-2"
              onClick={() => handleRequestClick(service.title)}
            >
              <FaPaperPlane className="text-white text-lg" />
              <span>Request Service</span>
            </button>
          </div>
        ))}
      </div>

      {/* Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-md relative">
            <button
              className="absolute top-2 right-3 text-gray-500 hover:text-gray-700 text-xl"
              onClick={handleClose}
            >
              &times;
            </button>
            <h3 className="text-xl font-bold text-blue-900 mb-4">
              Request: {selectedService}
            </h3>
            <form className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700">Your Name</label>
                <input
                  type="text"
                  className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">Email Address</label>
                <input
                  type="email"
                  className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">Message</label>
                <textarea
                  rows="3"
                  className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                  placeholder={`Tell us more about your needs for ${selectedService}`}
                ></textarea>
              </div>
              <button
                type="submit"
                className="w-full bg-blue-600 text-white py-2 px-4 rounded hover:bg-blue-700 transition"
              >
                Submit Request
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default ConsultancyServicesComponent;
